import styles from './CreditCardform.module.scss'
import classNames from 'classnames'
import { AWCButton } from '../GlobalComponents/Inputs/Inputs'

interface props {
    creditCardType: string
    submmiting: boolean
    handleClick(e: any): void
    cardName: string
    last4Number: string
    cvv: string
    expirationDate: string
    handleCVVchange(e: any): void
    handleExpirationDateChange(e: any): void
    handleCancel(): void
    error: string
}
export default function CreditCardForm({
    submmiting,
    handleClick,
    creditCardType,
    cardName,
    last4Number,
    cvv,
    expirationDate,
    handleCVVchange,
    handleExpirationDateChange,
    handleCancel,
    error,
}: props) {
    function getCardImageCss(name: string) {
        switch (name.toLowerCase()) {
        case 'visa':
            return styles.visaImageUpdate
        case 'master card':
            return styles.masterCardImageUpdate
        case 'maestro':
            return styles.maestroImageUpdate
        case 'american express':
            return styles.americanExpressImageUpdate
        case 'discover':
            return styles.discoverImageUpdate
        case 'jcb':
            return styles.jcbImageUpdate
        default:
            return ''
        }
    }

    const labelStyle = {
        color: 'black',
    }
    return (
        <div className={styles.formContainer}>
            <div className={styles.pageTitleCC}>Edit Credit Card</div>
            <form
                action="/"
                id="my-sample-form"
                method="post"
                className={classNames(styles.creditCardFormUpdate)}
            >
                <div className={styles.cardupdateCardNumber}>
                    <div id="card-number" className={styles.cardNumberDiv}>
                        <div
                            className={classNames(
                                styles.cardImageUpdate,
                                getCardImageCss(creditCardType)
                            )}
                            id="card-image"
                        ></div>
                        <div className={styles.labelDiv}>
                            <label style={labelStyle}>{' xxxx-xxxx-xxxx-' + last4Number}</label>
                        </div>
                    </div>
                </div>

                <div className={styles.cardinfoUpdateWrapper}>
                    <div className={styles.cardinfoCvv}>
                        <label className={styles.cardinfoLabel}>CVV</label>
                        <input
                            className={styles.inputWrapper}
                            type="text"
                            value={cvv}
                            onChange={handleCVVchange}
                        ></input>
                    </div>

                    <div className={styles.cardinfoExpDate}>
                        <label className={styles.cardinfoLabel}>Expiration Date</label>
                        <input
                            className={styles.inputWrapper}
                            type="text"
                            value={expirationDate}
                            onChange={handleExpirationDateChange}
                        ></input>
                    </div>
                </div>
                <div className={styles.cardinfoCardName}>
                    <label className={styles.errorLabel}>{error}</label>
                </div>
                <div className={styles.formUpdateBottom}>
                    <AWCButton
                        onClick={handleCancel}
                        style={{ flex: '80px 0 0', marginRight: 11 }}
                        type={'secondary'}
                    >
                        Cancel
                    </AWCButton>
                    <AWCButton
                        onClick={(e) => handleClick(e)}
                        style={{ flex: '80px 0 0', marginRight: 11 }}
                        type={submmiting ? 'primary' : 'disabled'}
                    >
                        Save
                    </AWCButton>
                </div>
            </form>
        </div>
    )
}
